// Centers `child` inside its horizontally scrolling tab strip `container`,
// scrolling ONLY that container.
//
// Never use element.scrollIntoView() for this: it scrolls every scrollable
// ancestor too, including the Layout's `.elakayPage` (overflow-x: hidden can
// still be scrolled by script). That shifted the whole page sideways and
// revealed the off-canvas Filter drawer (SideDrawer1), which then looked
// "open" after clicking an Edit Product / Settings tab.
export const centerTabInScroller = (container, child) => {
  if (!container || !child || container.scrollWidth <= container.clientWidth) return;
  const containerRect = container.getBoundingClientRect();
  const childRect = child.getBoundingClientRect();
  if (childRect.left >= containerRect.left && childRect.right <= containerRect.right) return;
  const left = container.scrollLeft + (childRect.left - containerRect.left) - (containerRect.width - childRect.width) / 2;
  const target = Math.max(0, Math.min(left, container.scrollWidth - container.clientWidth));
  if (typeof container.scrollTo === "function") container.scrollTo({ left: target });
  else container.scrollLeft = target;
};

export default centerTabInScroller;
